import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Form from '../../Form';

class MasterPriceLaddersForm extends Form {
    static fieldsValidation = {
        d: [['required'], 'decimal'],
        f: ['required', 'fractional'],
    };

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            data: props.data || {}
        });
    }

    onSave(e) {
        let { data, errors } = this.state;
        let { ladder, onSave } = this.props;
        let priceChanged = (ladder && data) && (data.f !== ladder.get('f') || data.d != ladder.get('d'));
        if (e) {
            e.preventDefault();
        }

        if (
            data.f && data.d &&
            priceChanged
        ) {
            (!errors.f && !errors.d) && onSave({...data, d: parseFloat(data.d)}, ladder.get('d'))
        }
    }

    onDelete(e) {
        let { data } = this.state;
        if (e) {
            e.preventDefault();
        }

        if(data.f && data.d){
            this.props.onDelete({...data, d: parseFloat(data.d)})
        }
    }

    onCreate(e) {
        let {data, errors} = this.state;
        if (e) {
            e.preventDefault();
        }

        Form.prototype.onSubmit.call(this, e);
        if (
            data.f && data.d &&
            !errors.f && !errors.d
        ) {
            this.props.onCreate({...data, d: parseFloat(data.d)})
            this.setState({
                ...this.state,
                data: { d: '', f: '' }
            })
        }

    }

    renderForm() {
        let { createNew, ladder } = this.props;
        let { data, errors } = this.state;
        let priceChanged = (ladder && !errors.f && !errors.d) && (data.f !== ladder.get('f') || data.d != ladder.get('d'));

        if(createNew){
            return (
                <section className="row sport-ladder-form">
                    <div className="col-2">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    { ...this.getFieldParameters('d') }
                                />
                            )
                        }
                    </div>
                    <div className="col-2">
                        {
                            this.getField(
                                <input
                                    type="text"
                                    { ...this.getFieldParameters('f') }
                                />
                            )
                        }
                    </div>
                    <div className="col-6">
                        <div className="buttons">
                            <a className="btn" href="#" onClick={ this.onCreate.bind(this) }>Save New</a>
                        </div>
                    </div>
                </section>
            )
        }

        return (
            <section className="row sport-ladder-form">
                <div className="col-2">
                    {
                        this.getField(
                            <input
                                type="text"
                                { ...this.getFieldParameters('d') }
                            />
                        )
                    }
                </div>
                <div className="col-2">
                    {
                        this.getField(
                            <input
                                type="text"
                                { ...this.getFieldParameters('f') }
                            />
                        )
                    }
                </div>
                <div className="col-6">
                    <div className="buttons">
                        <a className={ classNames( ['btn', { disabled: !priceChanged } ]) } href="#" onClick={ this.onSave.bind(this) }>Save</a>
                        <a className="btn" href="#" onClick={ this.onDelete.bind(this) }>Delete</a>
                    </div>
                </div>
            </section>
        )
    }
}

export default MasterPriceLaddersForm;
